import { useEffect, useState } from 'react'
import { audioSettings } from '../../services/AudioSettings/AudioSettings'
import './MuteButton.css'

export const MuteButton = () => {
  const [muted, setMuted] = useState(audioSettings.isMuted())

  useEffect(() => audioSettings.subscribe(setMuted), [])

  return (
    <button
      className="muteButton"
      type="button"
      onClick={() => audioSettings.toggle()}
      aria-label="Mute game audio"
      aria-pressed={muted}
      title={muted ? 'Unmute' : 'Mute'}
    >
      {muted ? '🔇' : '🔊'}
    </button>
  )
}
